import { render } from "./rule-item.vue?vue&type=template&id=2648fdc5&scoped=true&ts=true"
import script from "./rule-item.vue?vue&type=script&lang=tsx"
export * from "./rule-item.vue?vue&type=script&lang=tsx"

import "./rule-item.vue?vue&type=style&index=0&id=2648fdc5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2648fdc5"]])

export default __exports__